import React from 'react';
import './LideresTecnologicos.css';
import Footer from './Footer';

const LideresTecnologicos = () => {
  return (
    <div className="tecnologias-page">
      <div style={{ padding: "10px" }}>
        <section className="tecnologias-header">
          <h1>TECNOLOGÍAS PARA SU COMODIDAD</h1>
          <p>
          En CAIMA, la innovación no es un concepto, es nuestra esencia. Hemos llevado la implantologia dental al siguiente nivel, fusionando cuatro tecnologías clave en un solo flujo digital de precisión absoluta. 
          ¿El resultado? Tratamientos personalizados que transforman sonrisas, beneficiando la calidad de vida.
          </p>
          <button className="reserva-btn" onClick={() => {
          window.open('https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1', '_blank')
          }}>RESERVA TU HORA</button>
        </section>

        <div className="tecnologias-grid">
          <div className="tecnologia-item">
            <div className="tecnologia-imagen">
              <img src='/assets/images/cirugia-guiada.gif' alt="Cirugía Guiada por Software" />
            </div>
            <div className="tecnologia-info">
              <h3>CIRUGÍA GUIADA POR SOFTWARE</h3>
              <p>
              Cirugía Guiada por Software: Como un GPS de precisión milimétrica, planifica cada
               intervención con exactitud quirúrgica. Menos margen de error, más seguridad, mejores resultados, mayor comodidad
              </p>
            </div>
          </div>

          <div className="tecnologia-item">
            <div className="tecnologia-imagen">
              <img src='/assets/images/escaner-intraoral.gif' alt="Escáner Intraoral" />
            </div>
            <div className="tecnologia-info">
              <h3>ESCÁNER INTRAORAL</h3>
              <p>
              Digitalizamos la boca del paciente en alta resolución
               y simulamos cada procedimiento antes de tocar un solo diente. Así, la confianza no es una opción, es una certeza.
              </p>
            </div>
          </div>

          <div className="tecnologia-item">
            <div className="tecnologia-imagen">
              <img src='/assets/images/3d-mapping.gif' alt="Sistema 3D Mapping" />
            </div>
            <div className="tecnologia-info">
              <h3>SISTEMA SDI MATRIX</h3>
              <p>
              El lenguaje oculto de la mandíbula, ahora descifrado. Captura el 
              movimiento mandibular en tiempo real para entender cada detalle del funcionamiento articular para planificar su mejor tratamiento y evitar daños futuros.
              </p>
            </div>
          </div>

          <div className="tecnologia-item">
            <div className="tecnologia-imagen">
                <img src='/assets/images/face-scan.png' alt="Face Scan" />
            </div>
            <div className="tecnologia-info">
              <h3>ESCÁNER FACIAL</h3>
              <p>
              Este sistema fusiona toda la información con máxima precisión, 
              permitiéndonos diseñar dientes que no solo se ven bien, sino que funcionan en total sincronía con la anatomía y expresiones del paciente.
              </p>
            </div>
          </div>
        </div>

        <div className="tecnologias-footer">
          <h2>Bienvenidos al futuro de la Odontología, hoy</h2>
          <p> En CAIMA, nuestro objetivo es transformar sonrisas con inteligencia, 
            ciencia y arte desde hace una década..</p>
        </div>
      </div>
    </div>
  );
};

export default LideresTecnologicos;